import { render, staticRenderFns } from "./RiskAssessmentModal.vue?vue&type=template&id=325561b2&"
import script from "./RiskAssessmentModal.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports